import { render, staticRenderFns } from "./CatalogIndex.vue?vue&type=template&id=02348a15&scoped=true"
import script from "./CatalogIndex.vue?vue&type=script&lang=js"
export * from "./CatalogIndex.vue?vue&type=script&lang=js"
import style0 from "./CatalogIndex.vue?vue&type=style&index=0&id=02348a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02348a15",
  null
  
)

export default component.exports